  function SSSuperUserActions(slideshare_object){
    if (typeof slideshare_object === "undefined"){
      return;
    }
    this.setup_su_interaction(slideshare_object);
  }

  SSSuperUserActions.prototype.setup_su_interaction = function(slideshare_object) {
    if (slideshare_object.user.su) {
      $('.comment .action-comments', slideshare_object.svComments).show();
      $('#featured_value', slideshare_object.suonly).val(slideshare_object.category.featured);
    }
  };

  $('.j-action-add-lynda-course').on('click', function(e) {
    $('.j-overlay-lynda-course').toggle();
    $(window).scrollTop(0);
  });

export default SSSuperUserActions;